import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21030 20030"
    {...props}
  >
    <path
      d="M20730 12308c-3693-829-5861-1815-6651-3377 808-509 1995-908 3586-1265-1601 360-2868 527-3864 461-352-1792 704-4252 3027-7827-2308 3552-4122 5453-5900 5709-294-875-413-2040-413-3538 0 1498-119 2663-413 3538-1778-256-3592-2157-5900-5709 2323 3575 3379 6035 3027 7827-996 66-2263-102-3864-461 1591 357 2778 756 3586 1265-790 1562-2958 2548-6651 3377 3733-838 6199-947 7771-61-303 1025-968 2275-1975 3824 1004-1545 1874-2642 2688-3296 1272 1213 1731 3442 1731 6954 0-3512 459-5741 1731-6954 814 654 1684 1751 2688 3296-1007-1549-1672-2799-1975-3824 1573-885 4039-777 7771 61z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 600.858,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="stroke1 fill"
    />
  </svg>
)
export default SvgComponent
